import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from 'ngx-clipboard';
import { SoloDireccionesIpDirective } from '../../utilerias/directives/solo-direcciones-ip.directive';
import { SoloLetraEspacioNumeroAcentoDirective } from '../../utilerias/directives/solo-letra-espacio-numero-acento.directive';
import {
  PeticionesServidoresAplicaciones,
  ServidoresAplicacionesBase,
  VistaServidoresAplicaciones,
} from '../servidores-aplicaciones-comun/servidores-aplicaciones-base';

/** Relación general de servidores y aplicaciones; pinta la misma plantilla que la consulta COS con sus textos. */
@Component({
  selector: 'app-gestion-servidores-aplicaciones',
  standalone: true,
  templateUrl: '../consulta-servidores-aplicaciones/consulta-servidores-aplicaciones.component.html',
  imports: [
    FormsModule,
    NgFor,
    NgIf,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    MatTooltipModule,
    ClipboardModule,
    SoloDireccionesIpDirective,
    SoloLetraEspacioNumeroAcentoDirective,
  ],
})
export class GestionServidoresAplicacionesComponent extends ServidoresAplicacionesBase {
  readonly vista: VistaServidoresAplicaciones = {
    titulo: 'Relación Servidores y Aplicaciones',
    descripcion: 'Relación entre servidores, aplicaciones y usuarios.',
    tituloFiltros: 'Servidores',
    descripcionFiltros: 'Filtre primero el inventario de servidores y después navegue a usuarios y aplicaciones asociadas.',
    descripcionServidores: 'Seleccione un servidor para habilitar los paneles inferiores.',
    usuariosSinServidor: 'Seleccione un servidor para visualizar sus usuarios configurados.',
    maxLongitudSo: 25,
  };

  protected readonly peticiones: PeticionesServidoresAplicaciones = {
    totalServidores: (servidor) => this.fiseService.ConsultaNumServidores(servidor),
    paginaServidores: (consulta) => this.fiseService.consultarServidorPorIPPag(consulta),
    totalUsuariosServidor: (usuario) => this.fiseService.contarUsuarioPorSER(usuario),
    paginaUsuariosServidor: (consulta) => this.fiseService.obtenerUsuarioPorSERPag(consulta),
    totalAplicaciones: (aplicacion) => this.fiseService.ConsultaNumAplicaciones(aplicacion),
    paginaAplicaciones: (consulta) => this.fiseService.ObtenerAplicacionPorTipo(consulta),
    totalUsuariosAplicacion: (usuario) => this.fiseService.contarUsuarioPorApp(usuario),
    paginaUsuariosAplicacion: (consulta) => this.fiseService.obtenerUsuarioPorAppPag(consulta),
  };
}
